module.exports = [
	{
		"match": "javascript",
		"title": "Web Graphics",
		"content": "Like the scripts you see here, but don't love the look? Check out all the <a href=\"https://graphicriver.net/category/web-elements\">web graphics</a> on GraphicRiver.",
		"button_label": "Browse Graphics",
		"icon_source": null,
		"link": "https://graphicriver.net/category/web-elements"
	},
	{
		"match": "mobile",
		"title": "Mobile Themes",
		"content": "Be sure to check out all our <a href=\"https://themeforest.net/category/site-templates/mobile\">premium mobile themes</a> on ThemeForest.",
		"button_label": "Browse Mobile Themes",
		"icon_source": "wordpress.png",
		"link": "https://themeforest.net/category/site-templates/mobile"
	},
	{
		"match": "plugins/magento-extensions",
		"title": "Magento Themes",
		"content": "Be sure to check out all our <a href=\"https://themeforest.net/category/ecommerce/magento\">premium Magento themes</a> on ThemeForest.",
		"button_label": "Browse Magento Themes",
		"icon_source": "magneto-4d6853a18507111dc928627d1a4c1032.png",
		"link": "https://themeforest.net/category/ecommerce/magento"
	},
	{
		"match": "plugins/opencart",
		"title": "OpenCart Themes",
		"content": "Showcase your products in style with beautifully designed <a href=\"https://themeforest.net/category/ecommerce/opencart\">OpenCart themes</a> from ThemeForest. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/ecommerce/opencart"
	},
	{
		"match": "plugins/prestashop",
		"title": "PrestaShop Themes",
		"content": "Browse professionally designed <a href=\"https://themeforest.net/category/ecommerce/prestashop\">PrestaShop themes</a>, designed for functionality and conversion. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/ecommerce/prestashop"
	},
	{
		"match": "wordpress/ecommerce",
		"title": "eCommerce WordPress Themes",
		"content": "Turn your site into an online store with <a href=\"https://themeforest.net/category/wordpress/ecommerce\">eCommerce compatible WordPress themes</a> from ThemeForest. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/wordpress/ecommerce"
	},
	{
		"match": "wordpress/ecommerce/woocommerce",
		"title": "WooCommerce WordPress Themes",
		"content": "Create multi-functional WooCommerce websites using <a href=\"https://themeforest.net/category/wordpress/ecommerce/woocommerce\">WooCommerce compatible themes</a> from ThemeForest. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/wordpress/ecommerce/woocommerce"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/ads/codecanyon.json
// module id = 623
// module chunks = 1